var GenIcon = require('../lib').GenIcon

module.exports = function (props) {
   return GenIcon({"tag":"svg","attr":{"version":"1.1","id":"Arrow_long_down","x":"0px","y":"0px","viewBox":"0 0 20 20","enableBackground":"new 0 0 20 20","fill":"currentColor"},"child":[{"tag":"path","attr":{"d":"M10,19.25L4.5,14H8V1h4v13h3.5L10,19.25z"}}],"content":"\r\n"})(props);
};
